import UseGql from "@/services/graph-ql/useGql";
import useSignalRClient from "@/services/signal-R/signalr-hubs";
import { ToastTemplate } from "@/services/variables";
import { toast } from "react-toastify";
import { Get_Notifications } from "@/modules/crm/leads/graphql-queries";
import Lead_signalr from "@/modules/crm/leads/signalr-constants";
import { useDispatch, useSelector } from "react-redux";
import {
  setMarkAsRead,
  setNotificationToState,
  setPageInfo,
} from "@/store/slices/notifications/notificationsSlice";
import { useEffect } from "react";
import { getAllRequests } from "@/store/slices/requests";
import guid from "guid";
import useDesktopNotification from "../useDesktopNotification";
import { notificationTypes } from "@/store/slices/notifications/types";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";

const {
  hubName,
  InvokeMethodNames: { markAllAsRead },
  onReceiveMethodNames: {},
} = Lead_signalr;

// manage notification hook
const useLeadNotifications = (prop) => {
  const {
    hubName,
    onReceiveMethodNames: {
      onNotificationArrived,
      onUpdateNotificationResponse,
    },
  } = Lead_signalr;
  const profile = useSelector((state) => state?.auth?.profile);
  const { statuses, RTC } = useSignalRClient({ hubName });
  let getNotificationsGQL = UseGql(Get_Notifications);
  const { showNotification } = useDesktopNotification();

  const dispatch = useDispatch();
  const leadhub = RTC[hubName];
  const leadhubStatus = statuses[hubName];
  const requests = useSelector(getAllRequests);
  // notification listener
  useEffect(() => {
    let response = requests[onNotificationArrived];
    if (response) {
      console.log("Notification arrived successfully::", response);
      const payload = JSON.parse(JSON.stringify(response.notification));
      if (prop?.notify) {
        prop?.notify(payload);
      }

      if (
        prop?.desktopNotification &&
        payload.type == notificationTypes.leads.appointmentReminder
      ) {
        showNotification({
          title: payload.title,
          body: payload.description,
          icon: faCalendar,
        });
      }
      payload.loggedInUserId = profile?.UserID;
      if (payload.type != "LeadImportWaiting") {
        // stop pushing import waiting notificcation
        dispatch(setNotificationToState(payload));
      }
    }
  }, [requests[onNotificationArrived]]);

  // update notification listner
  useEffect(() => {
    let response = requests[onUpdateNotificationResponse];
    if (response) {
      if (response.isSuccess) {
        dispatch(setMarkAsRead(response.notification));
      }
    }
  }, [requests[onUpdateNotificationResponse]]);

  // get notifications from server
  const getNotifications = async (payload) => {
    try {
      return getNotificationsGQL.executeQuery(payload).then((response) => {
        const { data } = response;
        if (data?.notifications.items) {
          // exclude import waiting notificcation
          const notifications = data.notifications.items.filter(
            (notification) => notification?.type != "LeadImportWaiting"
          );
          console.log("Notifications fetched:: ", notifications);
          let recordsCount = data?.notifications.items.length;
          let page = data?.notifications.pageInfo;
          let totalCount = data?.notifications.totalCount;
          dispatch(
            setPageInfo({
              ...page,
              recordsCount,
              totalCount,
            })
          );
          // set api response, this will populate the form with saved data
          return notifications;
        }
      });
    } catch (error) {
      toast.error(ToastTemplate.error(error || error.message));
    }
  };

  const setNotificationIsRead = async (lastNotificationId) => {
    const payload = {
      id: lastNotificationId,
      requestId: guid.raw(),
    };
    return leadhub.invoke(markAllAsRead, payload).then((res) => {
      return res;
    });
  };

  return {
    getNotifications,
    setNotificationIsRead,
  };
};

export default useLeadNotifications;
